const utf8 = require("utf8");
const base64 = require("base-64");

export function normaliseBase64GeoJsonParam(encodedGeojson) {
  if (!encodedGeojson) {
    return null;
  }

  const normalised = String(encodedGeojson)
    .trim()
    .replace(/ /g, "+")
    .replace(/-/g, "+")
    .replace(/_/g, "/");

  return normalised.padEnd(normalised.length + ((4 - (normalised.length % 4)) % 4), "=");
}

export function decodeGeoJsonQueryParam(encodedGeojson) {
  const normalisedGeojson = normaliseBase64GeoJsonParam(encodedGeojson);

  if (!normalisedGeojson) {
    return null;
  }

  return JSON.parse(utf8.decode(base64.decode(normalisedGeojson)));
}

export function visitCoordinatePairs(coordinates, callback) {
  if (!Array.isArray(coordinates)) {
    return;
  }

  if (typeof coordinates[0] === "number" && typeof coordinates[1] === "number") {
    callback(coordinates);
    return;
  }

  coordinates.forEach((child) => visitCoordinatePairs(child, callback));
}

export function calculateGeoJsonBounds(geojson) {
  const features = geojson && Array.isArray(geojson.features) ? geojson.features : [];
  let minLat = Infinity;
  let minLon = Infinity;
  let maxLat = -Infinity;
  let maxLon = -Infinity;
  let points = 0;

  features.forEach((feature) => {
    if (!feature || !feature.geometry) {
      return;
    }

    visitCoordinatePairs(feature.geometry.coordinates, (coordinate) => {
      const lon = Number(coordinate[0]);
      const lat = Number(coordinate[1]);

      if (!Number.isFinite(lon) || !Number.isFinite(lat)) {
        return;
      }

      minLon = Math.min(minLon, lon);
      maxLon = Math.max(maxLon, lon);
      minLat = Math.min(minLat, lat);
      maxLat = Math.max(maxLat, lat);
      points++;
    });
  });

  return points > 0 ? [[minLat, minLon], [maxLat, maxLon]] : null;
}

export function loadGeoJsonFromSearch(search, loadGeojson, setNextBounds) {
  const params = new URLSearchParams(search || "");
  const encodedGeojson = params.get("gjson");

  if (!encodedGeojson) {
    return null;
  }

  const geojson = decodeGeoJsonQueryParam(encodedGeojson);

  if (geojson && typeof loadGeojson === "function") {
    loadGeojson(geojson);
  }

  const bounds = calculateGeoJsonBounds(geojson);
  if (bounds && typeof setNextBounds === "function") {
    setNextBounds(bounds);
  }

  return { geojson, bounds };
}
